import { useState, useEffect } from 'react';
import { API_ENDPOINTS, API_HEADERS } from '../constants/api';

export interface ScopeItem {
  heading?: string;
  title?: string;
  desc?: string;
  description?: string;
  [key: string]: any; // Allow any other fields
}

export const useScope = () => {
  const [scopeData, setScopeData] = useState<ScopeItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchScopeData = async () => {
      try {
        console.log('Fetching scope data from:', API_ENDPOINTS.scope);
        const response = await fetch(API_ENDPOINTS.scope, {
          method: 'GET',
          headers: API_HEADERS,
        });

        console.log('Response status:', response.status);
        console.log('Response ok:', response.ok);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Raw API response:', data);
        console.log('API response type:', typeof data);
        console.log('API response is array:', Array.isArray(data));
        
        if (Array.isArray(data)) {
          console.log('Number of items:', data.length);
          data.forEach((item, index) => {
            console.log(`Item ${index}:`, item);
            console.log(`Item ${index} keys:`, Object.keys(item));
            console.log(`Item ${index} heading:`, item.heading);
            console.log(`Item ${index} title:`, item.title);
            console.log(`Item ${index} desc:`, item.desc);
            console.log(`Item ${index} description:`, item.description);
            // Check for any other possible description fields
            Object.keys(item).forEach(key => {
              if (key.toLowerCase().includes('desc') || key.toLowerCase().includes('detail')) {
                console.log(`Item ${index} ${key}:`, item[key]);
              }
            });
          });
        }
        
        setScopeData(data);
      } catch (err) {
        console.error('Error fetching scope data:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch scope data');
      } finally {
        setLoading(false);
      }
    };

    fetchScopeData();
  }, []);

  return { scopeData, loading, error };
};
